import React, { useEffect, useState } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import ClockIcon from '@mui/icons-material/Schedule';
import { USER_ROLES } from "../../../utilities/constant";


const Boxes = ({ realtimeData , setQueuePopupVisible, queueDetail, loggedInUser}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth <= 768);
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const outerContainerStyle = {
    overflowX: "auto",
    padding: "8px 0",
    WebkitOverflowScrolling: "touch",
  };

const innerContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "stretch",
  justifyContent: "space-between",
  padding: isMobile ? "4px" : "8px",
  gap: isMobile ? "8px" : "16px",
  width: "100%",
};

const cardStyle = {
  background: "#faece6",
  borderRadius: "10px",
  // padding: "10px",
  boxShadow: "0 4px 6px rgba(180, 178, 178, 0.55)",
  transition: "all 0.2s ease",
  borderTop: "5px solid",
  flex: "1 1 280px",
  minWidth: "240px",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
};


  const iconContainerStyle = {
    // width: "50px",
    // height: "50px",
    // borderRadius: "50%",
    color: "black",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  };

  const getColor = (index) => {
    const colors = [
      "#FF6B6B", "#1fab02","#4ECDC4",  "#841dcc",
    ];
    return colors[index % colors.length];
  };

    const getBoxColor = (index) => {
    const colors = [
      "#ffd9d9","#e5f8e1","#e4f5f4", "#efe5f6",
    ];
    return colors[index % colors.length];
  };

  const stats = [
  {
    value: [
      { label: "Total", value: `${realtimeData.length}` },
      { label: "On Call", value: `${realtimeData.filter(item => item.agent?.login_status === "2").length}` },
      { label: "Online", value: `${realtimeData.filter(item => item.agent?.login_status === "1").length}` },
      { label: "Offline", value: `${realtimeData.filter(item => item.agent?.login_status === "0").length}` },
    ],
    label: "Agent",
  },
  {
    value: [
      { label: "Total", value: `00:00:00` },
      { label: "Average", value: "00:00:00" },
      { label: "Maximum", value: "00:00:00" },
    ],
    label: "Rings",
  },
  {
    value: [
      { label: "Waiting", value: `${queueDetail?.count || 0}` },
      { label: "Average", value: `${queueDetail?.average || "00:00:00"}` },
      { label: "Maximum", value: "00:00:00" },
      { label: "Max Delay", value: "00:02:49" },
      { label: "button", value: true },
    ],
    label: "Queue",
  },
  ...(loggedInUser !== USER_ROLES.CALL_CENTRE_ADMIN
    ? [
        {
          value: [
            { label: "Total", value: 2 },
            { label: "On Call", value: 1 },
            { label: "Idle", value: 1 },
            { label: "Offline", value: 0 },
          ],
          label: "Trunks",
        },
      ]
    : []),
];


  return (
    <div style={outerContainerStyle}>
      <div style={innerContainerStyle}>
        {stats.map((stat, index) => {
          const color = getColor(index);
          return (
            <div 
              key={index} 
              style={{
                ...cardStyle,
                backgroundColor: getBoxColor(index),
                borderTopColor: color,
              }}
            >
              <div style={{...iconContainerStyle}}>
                {stat.label}
              </div>
                <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    fontSize: '18px',
                    gap: '6px 22px',
                    padding: '10px',
                }}
                >
                {stat.value.map((item, idx) => {
                    const isTimeFormat = /^\d{2}:\d{2}:\d{2}$/.test(item.value);
                    const showButton = item.label === "button" && item.value === true;

                    // Detect if this is the Queue card
                    const isQueueCard = stat.label === "Queue";

                    return (
                        <div
                        key={idx}
                        style={{
                            width: showButton && isQueueCard ? '100%' : 'calc(50% - 20px)',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: showButton && isQueueCard ? 'center' : 'flex-start',
                            alignItems: showButton && isQueueCard ? 'center' : 'flex-start',
                            minHeight: showButton && isQueueCard ? '30px' : 'auto',
                        }}
                        >
                        <span>
                            {showButton ? (
                            <button
                                style={{
                                padding: '6px 12px',
                                border: '1px solid #4ECDC4',
                                borderRadius: 4,
                                fontSize: '14px',
                                background: "#b1dedb",
                                cursor: 'pointer',
                                }}
                                onClick={() => setQueuePopupVisible(true)}
                            >
                                View Details
                            </button>
                            ) : (
                            <>
                                {item.label}:{isTimeFormat && <br />}
                                <strong style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                {isTimeFormat && <ClockIcon style={{ fontSize: "18px" }} />}
                                {item.value}
                                </strong>
                            </>
                            )}
                        </span>
                        </div>
                    );
                })}

                </div>





              
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Boxes;